import { render, staticRenderFns } from "./UploadToast.vue?vue&type=template&id=2673c0fa&scoped=true&"
import script from "./UploadToast.vue?vue&type=script&lang=ts&"
export * from "./UploadToast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673c0fa",
  null
  
)

export default component.exports